import { circularQueue } from "./circular_queue";
import { debounce } from "./debounce";
import { APICall } from "./api_call";

const RateLimiterSettings = {
  maxQueueSize: 500,
  maxResend: 3,
  resendTimeout: 5000, //timing in millisecond, each resend timing = resendTimeout * resendCount;
  inactiveTimeout: 5000, //timing in millisecond
};
Object.freeze(RateLimiterSettings);

const RateLimiter = function (rateLimiterSettings, clientOptions) {
  const state = {
    promise: Promise.resolve(null),
  };
  const storage = new circularQueue(rateLimiterSettings.maxQueueSize);
  let apiCall = APICall(storage, clientOptions);

  const sendEvent = (event, forceUpdate = false) => {
    if (event != null) storage.push(event);
    if (storage.empty()) return state.promise;
    if (storage.full()) forceUpdate = true;
    state.promise = debounceAPICall(forceUpdate);
    return state.promise;
  };

  const sendBatch = () => {
    return apiCall.resendIfFail();
  };

  const debounceAPICall = new debounce(
    sendBatch,
    rateLimiterSettings.inactiveTimeout
  );

  const getVariable = (varRequestObj) => {
    // Current rate limiter is not applied but wrapping it up inside rate limiter for easy future extension
    return apiCall.getVariable(varRequestObj);
  };

  return Object.freeze({
    storage,
    sendEvent,
    getVariable,
  });
};

export { RateLimiter, RateLimiterSettings };
